export default "__VITE_ASSET__eciF0I2w__"